<header id="site-header" class="header">
  <div id="header-wrap">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <nav class="navbar navbar-expand-lg">
            <a class="navbar-brand logo" routerLink="/home">
              <img id="logo-img" class="img-fluid" src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" />
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span></span>
              <span></span>
              <span></span>
            </button>
            @if (headerTitle) {
              <div class="header-center-title" role="status">
                <h4 class="m-0">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
                    <path d="M12 11v5M12 7.5h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  {{ headerTitle }}
                </h4>
              </div>
            }
            @if (user) {
              <div class="right-nav align-items-center d-flex justify-content-end">
                <button
                  type="button"
                  class="hdr-cart"
                  [attr.aria-label]="cartAriaLabel"
                  routerLink="/marketplace/cart"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                    <path d="M3.25 4.75h2l2.15 9.4a1.75 1.75 0 0 0 1.7 1.35h7.3a1.75 1.75 0 0 0 1.7-1.32l1.4-5.43H6.2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="9.5" cy="19" r="1.25" />
                    <circle cx="16.5" cy="19" r="1.25" />
                  </svg>
                  @if (cartCount > 0) {
                    <span class="hdr-cart-badge" aria-hidden="true">
                      {{ cartCount > 99 ? '99+' : cartCount }}
                    </span>
                  }
                </button>
                <button
                  type="button"
                  class="hdr-bell"
                  [class.hdr-bell--unread]="hasNotifications"
                  [attr.aria-label]="notificationAriaLabel"
                  (click)="openinvitationpage()"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                    <path
                      d="M6.2 9.6a5.8 5.8 0 0 1 11.6 0c0 3.4.86 4.9 1.55 6.05.28.46-.07 1.1-.6 1.1H5.25c-.53 0-.88-.64-.6-1.1.69-1.15 1.55-2.65 1.55-6.05Z"
                      stroke-linejoin="round"
                    />
                    <path d="M9.4 18.75a2.6 2.6 0 0 0 5.2 0" stroke-linecap="round" />
                  </svg>
                  @if (hasNotifications) {
                    <span class="hdr-bell-badge" aria-hidden="true">
                      {{ notificationBadge }}
                    </span>
                  }
                </button>
                <div ngbDropdown class="header-login" placement="bottom-end">
                  <button type="button" id="dropdownBasic1" class="hdr-avatar" ngbDropdownToggle aria-label="Account menu">
                    <img [src]="profileImg" alt="" />
                    <span class="hdr-name">{{ user.display_name || user.name || 'Adventurer' }}</span>
                    <svg class="hdr-caret" viewBox="0 0 12 7" width="10" height="6" fill="none" aria-hidden="true">
                      <path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                  <div ngbDropdownMenu class="hdr-menu" aria-labelledby="dropdownBasic1">
                    <div class="hdr-menu-id">
                      <img class="hdr-menu-photo" [src]="profileImg" alt="" />
                      <div class="hdr-menu-who">
                        <div class="hdr-menu-name">{{ user.display_name || user.name || 'Adventurer' }}</div>
                        @if (planLabel) {
                          <div class="hdr-menu-meta"><span class="hdr-menu-plan">{{ planLabel }}</span></div>
                        } @else if (user.email) {
                          <div class="hdr-menu-meta">{{ user.email }}</div>
                        }
                      </div>
                    </div>

                    <div class="hdr-menu-list">
                      <div class="hdr-menu-group">Account</div>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem routerLink="/user-profile">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <circle cx="12" cy="8" r="3.25" />
                          <path d="M5.5 19.25c.7-3.1 3.3-5 6.5-5s5.8 1.9 6.5 5" stroke-linecap="round" />
                        </svg>
                        Profile
                      </button>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem (click)="navigateToSubscription()">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <path d="M12 3.75 4.75 7.5v4.2c0 4.6 3.1 8.1 7.25 9.05 4.15-.95 7.25-4.45 7.25-9.05V7.5L12 3.75Z" stroke-linejoin="round" />
                          <path d="M9.5 12.1 11.2 13.8 14.7 10.2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {{ hasPaidSubscription ? 'Manage subscription' : 'Subscription' }}
                      </button>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem (click)="openTokenCreditWindow()">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <circle cx="12" cy="12" r="7.25" />
                          <path d="M12 8.25v7.5M9.75 10.2c.5-.7 1.3-1.1 2.25-1.1 1.7 0 2.5.9 2.5 1.9 0 2.5-4.5 1.4-4.5 3.7 0 .95.85 1.85 2.55 1.85 1.05 0 1.85-.4 2.35-1.1" stroke-linecap="round" />
                        </svg>
                        Tokens / credits
                      </button>
                      <div class="hdr-menu-group">Store</div>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem routerLink="/marketplace/orders">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <path d="M6.75 4.75h10.5l1 14.5H5.75l1-14.5Z" stroke-linejoin="round" />
                          <path d="M9.5 8.25c0 1.6 1.1 2.5 2.5 2.5s2.5-.9 2.5-2.5" stroke-linecap="round" />
                        </svg>
                        My purchases
                      </button>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem routerLink="/marketplace/favorites">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <path d="M12 19.25S4.75 15 4.75 10.2a3.6 3.6 0 0 1 6.55-2.05L12 9.1l.7-.95a3.6 3.6 0 0 1 6.55 2.05C19.25 15 12 19.25 12 19.25Z"
                            stroke-linejoin="round" />
                        </svg>
                        My favorites
                      </button>
                      <button type="button" class="hdr-menu-item" ngbDropdownItem routerLink="/marketplace/vendor-dashboard">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                          <path d="M4.75 9.25h14.5l-1 10H5.75l-1-10Z" stroke-linejoin="round" />
                          <path d="M8.75 9.25v-1.5a3.25 3.25 0 0 1 6.5 0v1.5" stroke-linecap="round" />
                        </svg>
                        My shop
                      </button>
                    </div>

                    <button type="button" class="hdr-menu-item hdr-menu-item--danger" ngbDropdownItem (click)="logout()">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                        <path d="M15.5 8.5 19 12l-3.5 3.5M19 12H10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13 4.75h2.25A2.75 2.75 0 0 1 18 7.5v9a2.75 2.75 0 0 1-2.75 2.75H13M10.5 4.75H8.75A2.75 2.75 0 0 0 6 7.5v9a2.75 2.75 0 0 0 2.75 2.75H10.5" stroke-linecap="round" />
                      </svg>
                      Log out
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (!user) {
              <div class="right-nav align-items-center d-flex justify-content-end pointer">
                <button type="button" class="hdr-auth hdr-auth--ghost" (click)="loginWithRedirect()">Log in</button>
                <button type="button" class="hdr-auth hdr-auth--primary" (click)="redirectToSignUp()">Sign up</button>
              </div>
            }
          </nav>
        </div>
      </div>
    </div>
  </div>
</header>